// Export CSV côté navigateur d'une liste affichée (séparateur point-virgule, BOM UTF-8 pour les
// tableurs), avec la mention de l'environnement hors production.

function echapper(valeur: string): string {
  return /[;"\n\r]/.test(valeur) ? `"${valeur.replace(/"/g, '""')}"` : valeur;
}

export function contenuCsv(entetes: string[], lignes: string[][], environnement = import.meta.env.VITE_CC_ENVIRONNEMENT): string {
  const corps = [entetes, ...lignes].map((l) => l.map(echapper).join(';'));
  if (environnement && environnement !== 'production') corps.push(echapper(`Export établi dans un environnement de ${environnement}, sans valeur`));
  return `${String.fromCharCode(0xfeff)}${corps.join('\r\n')}\r\n`;
}

export function telechargerCsv(nom: string, entetes: string[], lignes: string[][]): void {
  telechargerBlob(nom, new Blob([contenuCsv(entetes, lignes)], { type: 'text/csv;charset=utf-8' }));
}

export function telechargerBlob(nom: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nom;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
